<script>
	import Layout from '../../layouts/default/index.svelte'
	import Logo from '../../components/logo/logo.svelte'
	import DocumentItem from '../../components/document-item/document-item.svelte'
	import InputFile from '../../components/input-file/input-file.svelte'
	import AddInput from '../../components/add-input/add-input.svelte'
	import Button from '../../components/button/button.svelte'
	import RoundInfoIco from '../../components/icons/round-info.svelte'
	import InputDrag from '../../components/input-drag/input.drag.svelte'
	import Input from '../../components/input/input.svelte'
	import ResultsCheck from '../../components/icons/result-check.svelte'
    import Auth from '../../components/auth/auth.svelte'
    import UploadSeparately from '../../components/upload-separately/upload-separately.svelte'
    import UploadEverything from '../../components/upload-everything/upload-everything.svelte'
    import uploadFilesStoreEverything from '../../store/upload/upload-everything'
    import uploadFilesStoreSeparately from '../../store/upload/upload-separately'
    import { navigate } from "svelte-routing"

    let isReading = false
    let uploadType = 'everything'
    let response
    let result

    uploadFilesStoreEverything.recognitionResult.subscribe(value => {
        console.log(value)
        if (Object.entries(value).length) {
            response = value
            result = value.result
        }
    })

    uploadFilesStoreSeparately.recognitionResult.subscribe(value => {
        if (Object.entries(value).length) {
            response = value
            result = value
        }
    })

    uploadFilesStoreEverything.isReading.subscribe(value => {
        isReading = value
    })
    uploadFilesStoreSeparately.isReading.subscribe(value => {
        isReading = value
    })

    function cleanData() {
        uploadFilesStoreEverything.clean()
        uploadFilesStoreSeparately.clean()
        navigate('/')
    }

    function confidenceToClass(confidence) {
        if (confidence === 0) {
            return 'danger'
        }
        if (confidence < 90) {
            return 'warning'
        }
        return ''
    }

</script>

<style lang="scss">
	h1 {
		font-family: 'Roboto', sans-serif;
		font-weight: 100;
		line-height: 52px;
		font-size: 48px;
		margin-top: 111px;
		text-align: center;
		padding: 0 50px;
		.strong {
			font-weight: 400;
		}
    }
    h2 {
        height: 14px;
        font-family: Roboto;
        font-size: 12px;
        font-weight: 500;
        letter-spacing: 0.86px;
        text-transform: uppercase;
        margin-bottom: 20px;
        color: #ffffff;
    }
	.content {
		max-width: 650px;
		padding: 0 20px;
		margin: 0 auto;
		.header {
		    padding-top: 50px;
            text-align: center;
            margin-bottom: 25px;
            .done {
                font-family: Roboto;
                font-size: 24px;
                font-weight: 300;
                line-height: 2.17;
                letter-spacing: 0.05px;
                text-align: center;
                color: #ffffff;
            }
            .confidence {
                font-family: Roboto;
                font-size: 48px;
                font-weight: 100;
                line-height: 1.08;
                letter-spacing: 0.1px;
                text-align: center;
                color: #ffffff;
                b {
                    font-weight: 900;
                    color: #aecd23;
                }
            }
		}
		.result-wrapper {
		    border-radius: 11px;
            border: solid 5px #2a2f2c;
            padding: 30px 25px;
            margin-bottom: 10px;
            @media screen and (max-width: 600px) {
                border: none;
                padding: 0;
            }
            table {
                width: 100%;
                margin-bottom: 40px;
                td {
                    padding-bottom: 10px;
                }
                &:last-child {
                    margin-bottom: 0;
                }
            }
            label {
                display: inline-block;
                font-family: Roboto;
                font-size: 12px;
                font-weight: 500;
                letter-spacing: 0.86px;
                padding-right: 15px;
                color: #c8c4c4;

            }

		}
		.actions {
		    margin-top: 20px;
            display:flex;
            @media screen and (max-width: 600px) {
                flex-direction: column;
            }
            > div {
                flex: 1 1 50%;
                &.left {
                    padding-left: 30px;
                    .message {
                        font-family: Roboto;
                        font-weight: 300;
                        font-size: 15px;
                        color: #FFFFFF;
                        letter-spacing: 0.2px;
                        line-height: 29px;
                        position: relative;
                        .ico {
                            position: absolute;
                            top: 2px;
                            left: -30px;
                        }
                    }
                    .message-info {
                        font-family: Roboto;
                        font-weight: 300;
                        font-size: 13px;
                        color: #808683;
                        letter-spacing: 0.17px;
                        line-height: 18px;

                    }
                }
                &.right {
                    text-align: right;
                }
            }
        }
	}
</style>

<Auth>
    <Layout>
        <div class="content">
            <div class="header">
                <ResultsCheck />
                <div class="done">And it’s done!</div>
                <div class="confidence">Confidence: <b>{Math.round(response.confidence*100)/100}</b></div>
            </div>
            <div class="result-wrapper">
                <h2>1) PERSONAL INFORMATION</h2>
                <table>
                    {#if result.surname}
                    <tr>
                        <td><label for="">SURNAME</label></td>
                        <td><Input className={confidenceToClass(result.surname.confidence)} value={result.surname.value} disabled /></td>
                    </tr>
                    {/if}
                    {#if result.name}
                    <tr>
                        <td><label for="">NAME</label></td>
                        <td><Input className={confidenceToClass(result.name.confidence)} value={result.name.value} disabled /></td>
                    </tr>
                    {/if}
                    {#if result.birthday}
                    <tr>
                        <td><label for="">DATE OF BIRTH</label></td>
                        <td><Input className={confidenceToClass(result.birthday.confidence)} value={result.birthday.value} disabled /></td>
                    </tr>
                    {/if}
                    {#if result.birthplace}
                    <tr>
                        <td><label for="">PLACE OF BIRTH</label></td>
                        <td><Input className={confidenceToClass(result.birthplace.confidence)} value={result.birthplace.value} disabled /></td>
                    </tr>
                    {/if}
                    {#if result.birthplace_district}
                    <tr>
                        <td><label for="">BIRTHPLACE DISTRICT</label></td>
                        <td><Input className={confidenceToClass(result.birthplace_district.confidence)} value={result.birthplace_district.value} disabled /></td>
                    </tr>
                    {/if}
                    {#if result.sex}
                    <tr>
                        <td><label for="">SEX</label></td>
                        <td><Input className={confidenceToClass(result.sex.confidence)} value={result.sex.value} disabled /></td>
                    </tr>
                    {/if}
                    {#if result.personal_number}
                    <tr>
                        <td><label for="">PERSONAL NO.</label></td>
                        <td><Input className={confidenceToClass(result.personal_number.confidence)} value={result.personal_number.value} disabled /></td>
                    </tr>
                    {/if}
                    {#if result.marital_status}
                    <tr>
                        <td><label for="">MARTIAL STATUS</label></td>
                        <td><Input className={confidenceToClass(result.marital_status.confidence)} value={result.marital_status.value} disabled /></td>
                    </tr>
                    {/if}
                    {#if result.academic_title}
                    <tr>
                        <td><label for="">AC. TITLE</label></td>
                        <td><Input className={confidenceToClass(result.academic_title.confidence)} value={result.academic_title.value} disabled /></td>
                    </tr>
                    {/if}
                </table>
                <h2>2) ADDRESS INFORMATION</h2>
                <table>
                    {#if result.address_street}
                    <tr>
                        <td><label for="">ADRESS STREET</label></td>
                        <td><Input className={confidenceToClass(result.address_street.confidence)} value={result.address_street.value} disabled /></td>
                    </tr>
                    {/if}
                    {#if result.address_number}
                    <tr>
                        <td><label for="">ADRESS STREET NUMBER</label></td>
                        <td><Input className={confidenceToClass(result.address_number.confidence)} value={result.address_number.value} disabled /></td>
                    </tr>
                    {/if}
                    {#if result.address_city_part}
                    <tr>
                        <td><label for="">ADRESS CITY PART</label></td>
                        <td><Input className={confidenceToClass(result.address_city_part.confidence)} value={result.address_city_part.value} disabled /></td>
                    </tr>
                    {/if}
                    {#if result.address_district}
                    <tr>
                        <td><label for="">ADRESS DISTRICT</label></td>
                        <td><Input className={confidenceToClass(result.address_district.confidence)} value={result.address_district.value} disabled /></td>
                    </tr>
                    {/if}
                    {#if result.address_city}
                    <tr>
                        <td><label for="">ADRESS CITY</label></td>
                        <td><Input className={confidenceToClass(result.address_city.confidence)} value={result.address_city.value} disabled /></td>
                    </tr>
                    {/if}
                </table>
                <h2>3) ID INFORMATION</h2>
                <table>
                    {#if result.id_number}
                    <tr>
                        <td><label for="">ID NO</label></td>
                        <td><Input className={confidenceToClass(result.id_number.confidence)} value={result.id_number.value} disabled /></td>
                    </tr>
                    {/if}
                    {#if result.id_issued}
                    <tr>
                        <td><label for="">ID ISSUED</label></td>
                        <td><Input className={confidenceToClass(result.id_issued.confidence)} value={result.id_issued.value} disabled /></td>
                    </tr>
                    {/if}
                    {#if result.id_expiration}
                    <tr>
                        <td><label for="">ID EXPIRATION</label></td>
                        <td><Input className={confidenceToClass(result.id_expiration.confidence)} value={result.id_expiration.value} disabled /></td>
                    </tr>
                    {/if}
                </table>
                {#if result.driving_license_number}
                <h2>DRIVING LICENSE INFORMATION</h2>
                <table>
                    <tr>
                        <td><label for="">DRIVING LICENSE NO</label></td>
                        <td><Input className={confidenceToClass(result.driving_license_number.confidence)} value={result.driving_license_number.value} disabled /></td>
                    </tr>
                    <tr>
                        <td><label for="">DRIVING LICENSE ISSUED</label></td>
                        <td><Input className={confidenceToClass(result.driving_license_issued.confidence)} value={result.driving_license_issued.value} disabled /></td>
                    </tr>
                    <tr>
                        <td><label for="">DRIVING LICENSE EXPIRATION</label></td>
                        <td><Input className={confidenceToClass(result.driving_license_expiration.confidence)} value={result.driving_license_expiration.value} disabled /></td>
                    </tr>
                </table>
                {/if}
                {#if result.passport_number}
                <h2>PASSPORT INFORMATION</h2>
                <table>
                    <tr>
                        <td><label for="">PASSPORT NO</label></td>
                        <td><Input className={confidenceToClass(result.passport_number.confidence)} value={result.passport_number.value} disabled /></td>
                    </tr>
                    <tr>
                        <td><label for="">PASSPORT ISSUED</label></td>
                        <td><Input className={confidenceToClass(result.passport_issued.confidence)} value={result.passport_issued.value} disabled /></td>
                    </tr>
                    <tr>
                        <td><label for="">PASSPORT EXPIRATION</label></td>
                        <td><Input className={confidenceToClass(result.passport_expiration.confidence)} value={result.passport_expiration.value} disabled /></td>
                    </tr>
                </table>
                {/if}
            </div>
            <div class="actions">
                <div class="left">
                </div>
                <div class="right">
                    <Button on:click={cleanData} text="Upload new documents" />
                </div>
            </div>
        </div>
    </Layout>
</Auth>
